var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Button, useCtx } from '..';
import s from './styles.module.css.json';
var baseUrl = 'https://github.com/datocms/plugins-sdk/blob/master/packages/sdk/src/types.ts';
function copyTextToClipboard(text) {
    var textArea = document.createElement('textarea');
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        document.execCommand('copy');
    }
    catch (err) {
        // NOP
    }
    document.body.removeChild(textArea);
}
function addFinalPeriod(text) {
    if (['!', '.'].includes(text[text.length - 1])) {
        return text;
    }
    return "".concat(text, ".");
}
function findChildrenById(manifest, id) {
    return manifest.children.find(function (child) { return child.id === id; });
}
function findShortText(signature) {
    return ((signature.comment &&
        addFinalPeriod(signature.comment.summary.map(function (chunk) { return chunk.text; }).join(''))) ||
        null);
}
function findFirstTag(signature, tagName) {
    if (!signature.comment || !signature.comment.blockTags) {
        return null;
    }
    var tagNode = signature.comment.blockTags.find(function (tag) { return tag.tag === tagName; });
    if (!tagNode) {
        return null;
    }
    return tagNode.content.map(function (chunk) { return chunk.text; }).join('');
}
function findExample(signature) {
    var _a;
    var example = findFirstTag(signature, '@example');
    if (!example) {
        return null;
    }
    var lines = example
        .split(/\n/)
        .filter(function (l, i, all) { return l.length !== 0 || (i !== 0 && i !== all.length - 1); });
    var spacesPerLine = lines.map(function (line) {
        var spaces = line.match(/^\s*/);
        return spaces ? spaces[0].length : 0;
    });
    var commonIndentation = Math.min.apply(Math, spacesPerLine);
    var result = lines
        .map(function (line) { return line.substring(commonIndentation); })
        .join('\n');
    return (_a = result.match(/```[a-z]*\n([\s\S]*?)\n```/)) === null || _a === void 0 ? void 0 : _a[1].trim();
}
function buildCtx(manifest, definition) {
    if (definition.type.type === 'intersection') {
        var result = [];
        for (var _i = 0, _a = definition.type.types; _i < _a.length; _i++) {
            var elementInIntersection = _a[_i];
            if (elementInIntersection.type === 'reference') {
                var innerDefinition = findChildrenById(manifest, elementInIntersection.id);
                result = __spreadArray(__spreadArray([], result, true), [buildCtx(manifest, innerDefinition)], false);
            }
        }
        return result.flat().filter(function (x) { return x; });
    }
    if (definition.type.type === 'reflection') {
        var properties = definition.type.declaration.children.filter(function (child) {
            return !['mode', 'getSettings', 'setHeight', 'bodyPadding'].includes(child.name);
        });
        if (properties.length === 0) {
            return null;
        }
        return {
            name: definition.name,
            description: findShortText(definition),
            properties: properties.map(function (child) {
                var _a, _b;
                if ((_b = (_a = child.type) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.signatures) {
                    child.signatures = child.type.declaration.signatures;
                }
                if (child.signatures) {
                    var signature = child.signatures[0];
                    return {
                        name: child.name,
                        type: 'function',
                        description: findShortText(signature),
                        example: findExample(signature),
                        group: definition.name,
                        lineNumber: child.sources[0].line,
                    };
                }
                return {
                    name: child.name,
                    type: 'property',
                    description: findShortText(child),
                    example: findExample(child),
                    groupDescription: findShortText(definition),
                    group: definition.name,
                    lineNumber: child.sources[0].line,
                };
            }),
        };
    }
    if (definition.type.type === 'reference') {
        var innerDefinition = findChildrenById(manifest, definition.type.id);
        return buildCtx(manifest, innerDefinition);
    }
    throw new Error("Don\t know how to handle ".concat(definition));
}
var ExpandablePane = function (_a) {
    var children = _a.children, label = _a.label;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    return (React.createElement("div", { className: s.panel },
        React.createElement("button", { type: "button", className: s.panelHandle, onClick: function () { return setOpen(function (open) { return !open; }); } }, label),
        open && React.createElement("div", { className: s.panelBody }, children)));
};
export function ContextInspector() {
    var _this = this;
    var ctx = useCtx();
    var _a = useState(null), groups = _a[0], setGroups = _a[1];
    useEffect(function () {
        var runner = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, manifest, connectParameters, hook, signature, ctxParameter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch('https://unpkg.com/datocms-plugin-sdk/types.json')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        manifest = _a.sent();
                        connectParameters = manifest.children.find(function (child) { return child.name === 'FullConnectParameters'; });
                        hook = connectParameters.type.declaration.children.find(function (hook) { return hook.name === ctx.mode; });
                        signature = hook.signatures
                            ? hook.signatures[0]
                            : hook.type.declaration.signatures[0];
                        ctxParameter = signature.parameters.find(function (p) { return p.name === 'ctx'; });
                        setGroups(buildCtx(manifest, findChildrenById(manifest, ctxParameter.type.id)));
                        return [2 /*return*/];
                }
            });
        }); };
        runner();
    }, [setGroups]);
    var handleCopy = function (text) {
        copyTextToClipboard(text);
        ctx.notice('Copied to clipboard!');
    };
    var handleRun = function (example) {
        Function("\n        \"use strict\";\n        return(\n          async function(ctx) {\n            try {\n              ".concat(example, "\n            } catch(e) {\n              console.error(e);\n              await ctx.alert('Execution failed! See console for errors!');\n            }\n          }\n        )\n      "))()(ctx);
    };
    return (React.createElement("div", { className: s.inspector }, groups === null || groups === void 0 ? void 0 : groups.map(function (group) {
        var name = group.name
            .replace('AdditionalMethods', 'Methods')
            .replace('AdditionalProperties', 'Properties')
            .replace('Methods', ' methods')
            .replace('Properties', ' properties')
            .replace('Utilities', ' utilities');
        return (React.createElement(ExpandablePane, { label: "".concat(name), key: name },
            React.createElement("div", { className: s.groupDescription }, group.description),
            React.createElement("div", { className: s.propertyGroup }, (group.properties || []).map(function (item) { return (React.createElement("div", { key: item.name, className: s.propertyOrMethod },
                React.createElement("div", { className: s.propertyOrMethodBody },
                    React.createElement("a", { className: s.propertyOrMethodName, href: "".concat(baseUrl, "#L").concat(item.lineNumber), target: "_blank", rel: "noreferrer" },
                        item.name,
                        item.type === 'function' ? '()' : ''),
                    React.createElement("div", null, item.description)),
                item.type === 'property' && (React.createElement("div", { className: s.propertyOrMethodExample },
                    React.createElement("pre", null, JSON.stringify(ctx[item.name], null, 2)),
                    React.createElement("div", { className: s.propertyOrMethodExampleActions },
                        React.createElement(Button, { type: "button", buttonSize: "xxs", onClick: handleCopy.bind(null, JSON.stringify(ctx[item.name], null, 2)) }, "Copy value")))),
                item.example && (React.createElement("div", { className: s.propertyOrMethodExample },
                    React.createElement("pre", null, item.example),
                    React.createElement("div", { className: s.propertyOrMethodExampleActions },
                        React.createElement(Button, { type: "button", buttonSize: "xxs", buttonType: "primary", onClick: handleRun.bind(null, item.example) }, "Run example"),
                        React.createElement(Button, { type: "button", buttonSize: "xxs", onClick: handleCopy.bind(null, item.example) }, "Copy example")))))); }))));
    })));
}
//# sourceMappingURL=index.js.map